<template>
  <div class="modal__trigger" @click="openModal">
    <slot name="trigger"></slot>
  </div>
  <div :id="modalId" class="modal js-modal micromodal-slide" aria-hidden="true" :data-type="props.type">
    <div class="modal__overlay" tabindex="-1" data-micromodal-close>
      <div
        class="modal__container js-modal-scrollable-container"
        :class="props.modalClass"
        data-qa="modal--div--div__modal-container"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="`${modalId}-title`"
        data-test="modal"
      >
        <header class="modal__header js-modal-header">
          <h2 :id="`${modalId}-title`" class="a11y-visually-hidden">{{ modalTitle }}</h2>
          <slot name="header"></slot>
          <button
            v-if="!hideCloseButton"
            class="btn-close-round"
            :aria-label="props.ariaConfig.close"
            data-micromodal-close
            data-test="modal__close"
            @click="closeModal"
          ></button>
        </header>
        <main :id="`${modalId}-content`" class="modal__content">
          <slot name="content"></slot>
        </main>
        <footer v-if="currentDevice.isMobile && $slots.footer" class="modal__footer">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch } from 'vue'

import Modal from '../../../../../src/shared/modal/modal.js'
import { currentDevice } from '../../../../core/utils/currentDevice'

const props = defineProps({
  modalId: {
    type: String,
    required: true,
  },
  hasHeader: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
  modalClass: {
    type: String,
    default: '',
  },
  hideCloseButton: {
    type: Boolean,
    default: false,
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
  ariaConfig: {
    type: Object,
    default: () => ({
      close: 'close',
    }),
  },
  modalTitle: {
    type: String,
    required: true,
  },
})

// const modalId = ref(`modal-${Date.now()}`)

const emit = defineEmits(['close'])

const openModal = () => {
  Modal.show(props.modalId, {
    onShow: () => {
      ScrollLock.on()
    },
    onClose: () => {
      ScrollLock.off()
      emit('close')
    },
  })
}

const closeModal = () => {
  Modal.close(props.modalId)
  emit('close')
}

watch(
  () => props.isOpen,
  isOpen => {
    if (isOpen) {
      openModal()
    } else {
      closeModal()
    }
  }
)
defineExpose({
  openModal,
  closeModal,
})
</script>

<style scoped>
.modal__content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.modal__trigger {
  cursor: pointer;
}
</style>
